import * as React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import type {NutshellState} from '../../../store';

import {useGetSessionUser} from '../../core/use-get-session-user';

import {CUE_CARD_COLLECTION} from '../consts/cue-card-collection';
import type {CueCard} from '../consts/cue-card-collection';
import {closeSidebar} from '../redux/glossary-actions';
import {getGlossaryKey} from '../redux/glossary-selectors';

import {GlossarySidebar} from './glossary-sidebar';
import {pageHasGlossary} from './helpers';

export function GlossarySidebarWrapper() {
    const {user} = useGetSessionUser();
    const glossaryKey = useSelector((state: NutshellState) => getGlossaryKey(state));
    const dispatch = useDispatch();

    if (!glossaryKey || !pageHasGlossary(glossaryKey)) {
        return null;
    }

    // @ts-expect-error
    const {sidebarTitle, cards} = CUE_CARD_COLLECTION[glossaryKey];

    return (
        <GlossarySidebar
            cards={cards.filter((card: CueCard) => {
                return !card.adminOnly || (user && user.isAdministrator);
            })}
            sidebarTitle={sidebarTitle}
            onClose={() => dispatch(closeSidebar())}
        />
    );
}
